<div class="p-px-24">
    <h1 class="fs-20 fw-7">Choix de la raison de non-validation</h1>
    <p class="fs-16 fw-3">Sélectionnez la raison pour laquelle vous ne validez pas cette mission. Votre feedback est essentiel pour améliorer la qualité des candidatures et notre processus de recrutement.</p>

  <app-custom-checkbox
    [formGroup]="formGroup"
    [controlName]="'motifsRefus'"
    [options]="reasonArray"
    type="radio"
  ></app-custom-checkbox>

        <app-custom-input
        *ngIf="formGroup.get('motifsRefus')?.value == 'Autre cause'"
        label="Commentaire"
        innerClass="my-px-16"
        [required]="false"
        [parentForm]="formGroup"
        controlName="comment"
        placeholder="Pouvez-vous nous donner plus d’informations concernant les causes de ce refus ? "
        type="textarea"
      ></app-custom-input>
      <div class="d-flex align-items-center justify-content-end">
        <app-button text="Annuler" (handleClick)="dialogRef.close()" [stroked]="true" color="primary" class="me-1" ></app-button>
        <app-button (handleClick)="rejectEvaluation()"  [loading]="loading" text="Confirmer et continuer"></app-button>
    </div>
</div>
